// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1483":"9a2b25b3","3558":"9a2b25b3","8595":"9a2b25b3","8828":"9a2b25b3"}[chunkId] + ".chunk.css";
};